import List from "./list/PeriodReports";

export default { List };
